import { useState } from "react";
import { toast } from "sonner";
import api from "../../../lib/api";

export default function NewsletterBlock({ data }) {
  const { title, subtitle } = data || {};
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      setDone(true);
      toast.success("Danke! Schau in dein Postfach.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Anmeldung fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-2xl mx-auto px-6 md:px-8">
        <div
          className="rounded-3xl p-8 md:p-10 border text-center"
          style={{ borderColor: "var(--wp-border)", backgroundColor: "var(--wp-cream)" }}
        >
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-4" style={{ backgroundColor: "var(--wp-olive)", color: "var(--wp-cream)" }}>
            <i className="fa-solid fa-envelope" />
          </div>
          <h3 className="font-display text-2xl md:text-3xl mb-2" style={{ color: "var(--wp-olive)" }}>
            {title || "Newsletter abonnieren"}
          </h3>
          {subtitle && <p className="text-sm md:text-base mb-5" style={{ color: "var(--wp-text-muted)" }}>{subtitle}</p>}
          {done ? (
            <div className="text-sm" style={{ color: "var(--wp-primary)" }}>
              <i className="fa-solid fa-circle-check mr-2" />Erfolgreich angemeldet.
            </div>
          ) : (
            <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 max-w-md mx-auto" data-testid="newsletter-block-form">
              <input
                type="email"
                required
                placeholder="deine@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 px-4 py-3 rounded-full border text-sm"
                style={{ borderColor: "var(--wp-border)" }}
                data-testid="newsletter-block-email"
              />
              <button type="submit" disabled={busy} className="btn-primary !rounded-full" data-testid="newsletter-block-submit">
                {busy ? "…" : "Abonnieren"}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
